import { PropsWithChildren, ReactElement } from "react";
import { List } from "immutable";
import { DropdownData } from "common/components/Dropdown/Data/DropdownData";
import { IFieldBaseProps } from "common/components/Field";
import { DropdownRecord } from "common/components/Dropdown/Dropdown";
import { Nullable } from "common/types";
import { Props } from "react-select";

export interface IDropdownProps extends IFieldBaseProps<"simpleDropdown" | "multiDropdown"> {
  query: () => List<DropdownRecord>;
  validate?: (value: DropdownRecord | List<DropdownRecord>, rootRecord?: any) => Nullable<string>;
  placeholder: string;
  selectProps?: Partial<Props>;
  onValueChange?: (value: List<DropdownRecord>) => void;
  allowCustomValue?: boolean;
}

/**
 *  Dropdown component
 */
export const Dropdown = ({
  id,
  label,
  name,
  type,
  query,
  validate,
  disabled = false,
  placeholder,
  selectProps = {},
  onValueChange,
  allowCustomValue = false,
}: PropsWithChildren<IDropdownProps>): ReactElement<any> => {
  const options = query();
  let isMulti = false;
  let closeMenuOnSelect = true;

  if (type === "multiDropdown") {
    isMulti = true;
    closeMenuOnSelect = false;
  }

  return (
    <DropdownData
      id={id}
      label={label}
      name={name}
      disabled={disabled}
      validate={validate}
      isMulti={isMulti}
      closeMenuOnSelect={closeMenuOnSelect}
      isLoading={false}
      options={options}
      placeholder={placeholder}
      selectProps={selectProps}
      allowCustomValue={allowCustomValue}
      onValueChange={onValueChange}></DropdownData>
  );
};
